import { Configuration } from "../Models/configuration";
import { resetTick, startTimeline, stopTimeline } from "./timeline.service";
import store, { dispatch } from "Redux/store";
import {
    clearLogs,
    setConsumers,
    setGlobal,
    setNodes,
    setPartitions,
    setProducer,
} from "Redux/actions";
import { getConfig } from "Redux/selectors";
import { setupNodes } from "./nodes.service";
import { setupPartitions, syncReplicas } from "./partitions.service";
import {
    setupProducer,
    startProducer,
    stopProducer,
} from "./producers.service";
import {
    setupConsumers,
    startConsumers,
    stopConsumers,
} from "./consumers.service";
import { createLogs } from "./logs.service";

export const setup = (config?: Configuration) => {
    if (!config) return;
    stopTimeline();

    const { nodes, partitions, producer, consumers } = store.getState();

    const newNodes = setupNodes(config, nodes);
    const newPartitions = setupPartitions(config, partitions, newNodes);

    const newConsumers = setupConsumers(config, consumers, newPartitions);
    const newProducer = setupProducer(config, producer);

    dispatch(setNodes(newNodes));
    dispatch(setPartitions(newPartitions));
    createLogs(newPartitions);
    syncReplicas(newPartitions);
    dispatch(setProducer(newProducer));

    startProducer(newProducer);

    if (newConsumers) {
        dispatch(setConsumers(newConsumers));
        startConsumers(newConsumers);
    }
    startTimeline();
};

export const reset = () => {
    stop();
    const { producer } = store.getState();
    dispatch(setNodes([]));
    dispatch(setConsumers([]));
    dispatch(setPartitions([]));
    dispatch(
        setProducer({
            ...producer,
            recentMessage: undefined,
            counter: 0,
        })
    );
    dispatch(clearLogs());
    resetTick();
    dispatch(setGlobal({ runSeed: Date.now() }));
    setup(getConfig(store.getState()));
};

const stop = () => {
    stopProducer();
    stopConsumers();
};
